const AboutValues = () => {
  const values = [
    {
      icon: 'ri-award-line',
      title: 'Kwaliteit',
      description: 'We gebruiken alleen de beste materialen en technieken voor een duurzaam resultaat.'
    },
    {
      icon: 'ri-time-line',
      title: 'Betrouwbaarheid',
      description: 'We houden ons aan afspraken en leveren projecten op tijd en binnen budget.'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'Klantgericht',
      description: 'Uw tevredenheid staat centraal. We luisteren naar uw wensen en adviseren eerlijk.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Vakmanschap',
      description: 'Jarenlange ervaring en passie voor het vak zorgen voor perfecte afwerking.'
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'serif' }}>
            Onze Waarden
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Deze principes vormen de basis van alles wat we doen
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="w-16 h-16 bg-gray-900 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${value.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {value.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutValues;